import { createAsyncThunk } from '@reduxjs/toolkit';
import admissionAPI from '../../../config/api/admissionAPI';
import { thunkHandler } from '../helper/thunkHandler';

export const findPaymentType = createAsyncThunk(
  'paymentType/findPaymentType',
  async (_, thunkAPI) => {
    const accessToken = localStorage.getItem('access_token');

    return thunkHandler(
      admissionAPI.get('/payment-types', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      thunkAPI,
    );
  },
);
